<template>
  <nav class="tabbar" aria-label="主导航">
    <button v-for="item in items" :key="item.path" :class="['tabbar__item', { 'is-active': isActive(item) }]" @click="go(item.path)">
      <Icon :type="item.icon" size="22" />
      <span>{{ item.label }}</span>
    </button>
  </nav>
</template>

<script>
import { retainedQuery } from '../utils/session'

export default {
  name: 'H5TabBar',
  data () {
    return {
      items: [
        { label: '首页', path: '/home', icon: 'ios-home' },
        { label: '报告', path: '/report', icon: 'ios-search' }
      ]
    }
  },
  methods: {
    isActive (item) {
      return this.$route.path === item.path
    },
    go (path) {
      if (this.$route.path === path) return
      this.$router.push({ path, query: retainedQuery() })
    }
  }
}
</script>

<style scoped>
.tabbar {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(60px + constant(safe-area-inset-bottom));
  height: calc(60px + env(safe-area-inset-bottom));
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid var(--wpc-line);
}
.tabbar__item {
  min-height: 60px;
  border: 0;
  background: transparent;
  color: var(--wpc-text-muted);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 12px;
  cursor: pointer;
}
.tabbar__item.is-active {
  color: var(--wpc-primary);
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/H5TabBar.vue